const agents = {
  title: "Agentes",
  subtitle: "Potencialize seus processos ágeis",
  description: "Gerencie seus agentes de IA",
  moreIntegrations: "+{{count}} mais integrações",
  empty: {
    title: "Nenhum agente encontrado",
    description: "Crie um novo agente para começar"
  },
  new: {
    title: "Novo Agente",
    description: "Crie um novo agente"
  },
  install: "Instalar",
  installing: "Instalando...",
  installSuccess: "Agente {{name}} instalado com sucesso",
  comingSoon: "Em breve",
  uninstall: "Desinstalar",
  uninstalling: "Desinstalando...",
  uninstallSuccess: "Agente {{name}} desinstalado com sucesso",
  confirmUninstall: "Desinstalar {{name}}",
  confirmUninstallDescription: "Esta ação é irreversível. Para confirmar, digite o nome do workspace atual abaixo.",
  errors: {
    missingInfo: "Informações necessárias faltando",
    invalidAgent: "Agente inválido ou não encontrado",
    installFailed: "Falha ao instalar o agente",
    uninstallFailed: "Falha ao desinstalar o agente",
    nameNotMatch: "O nome digitado não corresponde ao nome do agente",
    workspaceNameNotMatch: "O nome digitado não corresponde ao nome do workspace atual",
    workspaceDataError: "Erro ao obter informações do workspace"
  },
  untitled: "Sem título",
  settings: {
    title: "Configurações do Agente",
    description: "Configure seu agente de IA",
    type: "Tipo",
    version: "Versão",
    neverPublished: "Nunca publicado",
    saveButton: {
      label: "Salvar",
      saving: "Salvando...",
      success: "Alterações salvas com sucesso!",
      error: "Erro ao salvar as alterações"
    },
    publishButton: {
      label: "Publicar",
      publishing: "Publicando...",
      success: "Agente publicado com sucesso!",
      error: "Erro ao publicar o agente",
      confirmTitle: "Confirmar Publicação",
      confirmDescription: "Dê um nome e uma descrição para esta versão do agente.",
      confirm: "Sim, publicar",
      cancel: "Cancelar",
      versionNameLabel: "Nome da versão",
      versionNamePlaceholder: "Ex: Versão Beta 1.0",
      versionNameError: "Este nome já está em uso. Por favor, escolha outro nome.",
      versionNameRequired: "O nome da versão é obrigatório",
      versionDescriptionLabel: "Descrição da versão",
      versionDescriptionPlaceholder: "Ex: Melhorias na integração com API externa",
      versionDescriptionRequired: "A descrição da versão é obrigatória",
      workflowSchemaRequired: "O esquema do workflow é obrigatório",
      versionAutoGenerated: "O número da versão é gerado automaticamente e não pode ser editado"
    },
    unsavedChangesDialog: {
      title: "Alterações não publicadas",
      description: "Você possui alterações que ainda não foram publicadas. Se sair agora, essas mudanças serão perdidas.",
      continueEditing: "Continuar Editando",
      discardAndExit: "Descartar e Sair"
    },
    notFound: "Agente não encontrado",
    disconnected: "Desconectado",
    updateSuccess: "Agente atualizado",
    updateSuccessDescription: "O agente foi atualizado com sucesso",
    updateErrorDescription: "Ocorreu um erro ao atualizar o agente",
    publishSuccess: "Agente publicado",
    publishSuccessDescription: "O agente foi publicado com sucesso",
    publishErrorDescription: "Ocorreu um erro ao publicar o agente",
    unsavedChanges: "Há alterações não publicadas",
    tabs: {
      integrations: "Integrações",
      prompts: "Prompts",
      parameters: "Parâmetros",
      workflow: "Workflow",
      versions: 'Versões',
      executions: "Execuções",
      dangerZone: "Zona de Perigo"
    },
    dangerZoneDescription: "Ações perigosas como desinstalação podem causar perda de dados. Prossiga com cautela.",
    uninstallButton: {
      label: "Desinstalar este agente",
      confirmTitle: "Confirmar desinstalação",
      confirmDescription: "Esta ação é irreversível e removerá o agente do workspace atual. Para confirmar, digite o nome exato do workspace.",
      confirmAgentNameLabel: "Nome do workspace",
      confirmAgentNamePlaceholder: "Digite o nome do workspace para confirmar",
      typeName: "Digite o nome",
      uninstalling: "Desinstalando...",
      uninstallingTitle: "Desinstalando agente",
      uninstallingProgress: "Progresso: {{progress}}%",
      uninstallingDescription: "Removendo {{name}} do workspace atual",
      uninstallingStep: "Desinstalando",
      uninstallingMessage: "Isso pode levar alguns instantes, por favor aguarde...",
      uninstalledMessage: "Desinstalação concluída! Redirecionando...",
      confirm: "Desinstalar",
      cancel: "Cancelar"
    },
    general: {
      version: "Versão",
      lastPublished: "Última publicação",
      noDescription: "Sem descrição"
    },
    prompts: {
      title: "Prompts do Sistema",
      add: "Adicionar seção",
      delete: "Excluir",
      preview: "Visualizar",
      edit: "Editar",
      untitled: "Sem título",
      noSections: "Nenhuma seção de prompt configurada",
      cannotDeleteLast: "Não é possível excluir a última seção de prompt",
      locked: "Este prompt está bloqueado e não pode ser editado",
      cancel: "Cancelar",
      systemPrompt: "Prompt do Sistema",
      systemPromptHelp: "Este é o prompt do sistema que será usado para guiar o comportamento do agente"
    },
    parameters: {
      title: "Parâmetros do Agente",
      saveButton: "Salvar Parâmetros",
      saved: "Parâmetros salvos com sucesso",
      savedSuccess: "Parâmetros salvos com sucesso",
      missingRequired: "Campos obrigatórios não preenchidos",
      missingFields: "Campos obrigatórios ausentes",
      saveError: "Erro ao salvar parâmetros",
      missingRequiredField: "Campo obrigatório não preenchido: {{field}}",
      noParametersTitle: "Sem parâmetros definidos",
      noParametersDescription: "Este agente não possui parâmetros configuráveis definidos.",
      enabled: "Habilitado",
      disabled: "Desabilitado",
      required: "Obrigatório",
      types: {
        string: "Texto",
        number: "Número",
        select: "Seleção",
        boolean: "Sim/Não",
        json: "JSON"
      }
    },
    versions: {
      title: "Histórico de Versões",
      subtitle: "Histórico completo de todas as versões publicadas deste agente",
      noVersions: 'Nenhuma versão encontrada',
      versionNumber: 'Versão {{number}}',
      createdAt: 'Criada {{time}}',
      name: 'Nome',
      status: 'Status',
      description: 'Descrição',
      webhookPath: "Caminho do Webhook",
      webhookEndpoint: "Endpoint do Webhook",
      pathCopied: "Caminho copiado para a área de transferência",
      triggers: "Triggers Vinculados",
      restore: {
        button: 'Restaurar',
        confirmTitle: 'Restaurar Versão',
        confirmDescription: 'Isso irá restaurar esta versão como a versão atual do agente. A versão atual será arquivada. Deseja continuar?',
        confirm: 'Sim, restaurar',
        cancel: 'Cancelar',
        success: 'Versão restaurada com sucesso!',
        error: 'Erro ao restaurar versão'
      },
      statusLabels: {
        active: 'Ativo',
        inactive: 'Inativo',
        error: 'Erro',
        current: 'Atual',
        archived: 'Arquivada',
        published: 'Publicada',
        draft: 'Rascunho',
        deprecated: 'Descontinuada'
      }
    },
    versionHistory: {
      list_title: 'Histórico de Versões',
      list_subtitle: 'Histórico completo de todas as versões publicadas deste agente',
      empty: 'Nenhuma versão publicada',
      current: 'Versão atual',
      published: 'Publicado em',
      by: 'por',
      description: 'Descrição',
      actions: 'Ações'
    },
  },
  workflow: {
    title: "Workflow",
    description: "Configure o workflow do agente",
    save: "Salvar",
    saving: "Salvando...",
    input: "Entrada",
    noInputTitle: "Sem entrada ainda!",
    noInputDesc: "Execute o node anterior para ver os dados de entrada aqui",
    noOutputTitle: "Sem saída ainda!",
    noOutputDesc: "Execute este node para ver os dados de saída aqui",
    executing: "Executando...",
    test: {
      title: 'Testar',
      button: 'Testar',
      description: 'Testar este node com a configuração atual',
      testing: 'Testando...',
      noTrigger: "É necessário configurar um gatilho (trigger) para o workflow antes de testá-lo",
      noTriggerTitle: "Gatilho não encontrado",
      error: "Erro ao testar workflow",
      errorTitle: "Erro no teste",
      pause: "Pausar execução"
    },
    testSuccessTitle: "Sucesso",
    testSuccess: "Workflow executado com sucesso",
    testErrorTitle: "Erro",
    testError: "Erro ao executar o workflow",
    nodeError: "Erro ao executar o node",
    nodeErrorGeneric: "Ocorreu um erro ao executar este node",
    noFields: "Este workflow não tem campos para configurar",
    noOutput: "Execute o teste para ver a saída aqui",
    tested: "Teste Concluído",
    testedSuccess: "Fluxo de trabalho testado com sucesso!",
    noWorkflow: "Nenhum workflow encontrado",
    noWorkflowDescription: "Este agente ainda não tem um workflow configurado.",
    unnamedNode: "Nó",
    loading: "Carregando workflow...",
    error: "Erro ao carregar o workflow do agente",
    new: "Novo Fluxo",
    create: "Criar",
    created: "Fluxo criado com sucesso",
    createError: "Erro ao criar fluxo",
    updated: "Fluxo atualizado com sucesso",
    updateError: "Erro ao atualizar fluxo",
    deleted: "Fluxo excluído com sucesso",
    deleteError: "Erro ao excluir fluxo",
    deleteConfirm: "Tem certeza que deseja excluir este fluxo?",
    nameRequired: "Nome é obrigatório",
    namePlaceholder: "Digite o nome do fluxo",
    select: "Selecionar Fluxo",
    selectPlaceholder: "Selecione um fluxo",
    components: "Componentes",
    nodeConfigSaved: "Configurações do node salvas com sucesso",
    nodeDeleted: "Node excluído com sucesso",
    node: {
      config: {
        title: "Configuração do Nó",
        description: "Configure os parâmetros do node",
        save: "Salvar",
        saving: "Salvando...",
        noFields: "Este node não possui campos para configurar",
        output: "Saída",
        noOutput: "Execute o teste para ver a saída",
        test: "Testar Node",
        testing: "Testando node...",
        testError: "Erro ao executar o node",
        testErrorTitle: "Erro no teste",
        testSuccess: "Node executado com sucesso",
        testSuccessTitle: "Sucesso"
      },
      error: {
        code: "Código do erro",
        type: "Tipo do erro",
        details: "Detalhes"
      },
      menu: {
        configure: "Configurar",
        delete: "Excluir"
      },
      title: {
        updated: "Título do node atualizado com sucesso",
        updateError: "Erro ao atualizar título do node"
      }
    },
    nodeConfig: {
      saveSuccess: "Configurações salvas",
      configurationUpdated: "As configurações do nó foram atualizadas com sucesso",
      saveError: "Erro ao salvar",
      saved: 'Configuração do node salva com sucesso',
      test: {
        success: "Teste realizado com sucesso",
        outputSaved: "Saída do teste foi salva"
      },
      mapping: {
        addItem: 'Adicionar Item',
        removeItem: "Remover",
        item: "Item",
        sourceField: "Campo de Origem",
        targetParameter: "Parâmetro de Destino",
        valueType: "Tipo do Valor",
        transformation: "Transformação",
        defaultValue: "Valor Padrão",
        types: {
          string: "Texto",
          number: "Número",
          boolean: "Booleano",
          object: "Objeto",
          array: "Lista"
        },
        transformations: {
          none: "Nenhuma",
          trim: "Remover Espaços",
          lowercase: "Minúsculas",
          uppercase: "Maiúsculas",
          capitalize: "Capitalizar"
        }
      },
      operators: {
        placeholder: 'Selecione o operador',
        starts_with: 'começa com',
        ends_with: 'termina com',
        contains: 'contém',
        equals: 'é igual a',
        not_equals: 'não é igual a',
        greater_than: 'é maior que',
        less_than: 'é menor que',
        greater_equals: 'é maior ou igual a',
        less_equals: 'é menor ou igual a',
        exists: 'existe',
        not_exists: 'não existe',
        empty: 'está vazio',
        not_empty: 'não está vazio',
        and: 'E',
        or: 'OU'
      }
    },
    categories: {
      API: "APIs",
      Databases: "Bancos de Dados",
      Files: "Arquivos",
      Embeddings: "Embeddings",
      Triggers: "Gatilhos",
      Transformers: "Transformadores",
      Chats: "Chats",
      "Knowledge Base": "Base de Conhecimento",
      Logic: "Lógica",
      other: "Outros",
      Service: "Serviços"
    },
    nodeTypes: {
      input: "Entrada de Dados",
      output: "Saída de Dados",
      process: "Processamento",
      condition: "Condição",
      loop: "Repetição"
    },
    nodes: {
      API: {
        title: "APIs",
        description: "Componentes para integração com APIs externas"
      },
      Databases: {
        title: "Bancos de Dados",
        description: "Componentes para integração com bancos de dados"
      },
      Files: {
        title: "Arquivos",
        description: "Componentes para manipulação de arquivos"
      },
      Embeddings: {
        title: "Embeddings",
        description: "Componentes para processamento de embeddings"
      },
      Triggers: {
        title: "Gatilhos",
        description: "Componentes para automação de fluxos"
      },
      other: {
        title: "Outros",
        description: "Outros componentes"
      }
    },
    triggers: {
      schedule: "Agendamento",
      webhook: "Webhook",
      manual: "Manual"
    },
    status: {
      draft: "Rascunho",
      active: "Ativo",
      inactive: "Inativo",
      error: "Erro"
    },
    executions: {
      title: "Execuções",
      description: "Histórico de execuções do workflow",
      columns: {
        id: {
          label: 'ID'
        },
        status: {
          label: 'Status'
        },
        agentVersion: {
          label: 'Versão do Agente'
        },
        version: {
          label: 'Versão'
        },
        startedAt: {
          label: 'Iniciado em'
        },
        completedAt: {
          label: 'Finalizado em'
        }
      },
      status: {
        pending: 'Pendente',
        running: 'Em Execução',
        completed: 'Concluído',
        error: 'Erro',
        canceled: 'Cancelado'
      },
      noExecutions: "Nenhuma execução encontrada",
      execute: "Executar",
      executing: "Executando...",
      executeSuccess: "Workflow executado com sucesso",
      executeSuccessTitle: "Sucesso",
      executeError: "Erro ao executar workflow",
      executeErrorTitle: "Erro",
      actions: {
        viewDetails: "Ver detalhes"
      },
      details: {
        title: "Detalhes da Execução",
        subtitle: "Lista de logs dos nós desta execução",
        nodeTitle: "Título",
        nodeType: "Tipo do Nó",
        startedAt: "Iniciado em",
        completedAt: "Finalizado em",
        status: "Status",
        details: "Detalhes",
        input: "Entrada",
        processingLog: "Processamento",
        noProcessingLog: "Nenhum log de processamento capturado para esta execução.",
        downloadReport: "Baixar Log",
        output: "Saída",
        error: "Erro",
        noLogs: "Nenhum log encontrado para esta execução."
      }
    },
    webhook: {
      waiting_title: "Aguardando Webhook",
      waiting_message: "Aguardando resposta do webhook...",
      webhook_url: "URL do Webhook",
      cancel_button: "Cancelar",
      timeout: "Tempo limite excedido",
      timeout_description: "O webhook não respondeu no tempo esperado",
      waiting: "Aguardando resposta do webhook",
      waiting_description: "Aguarde enquanto o webhook é processado",
      success: "Webhook processado com sucesso",
      success_description: "O webhook foi processado com sucesso",
      error: "Erro ao processar o webhook",
      error_description: "Ocorreu um erro ao processar o webhook",
      cancel: "Cancelar",
      cancel_description: "Cancelar o processamento do webhook"
    }
  },
  executions: {
    status: "Status",
    startedAt: "Iniciado em",
    completedAt: "Finalizado em",
    agentVersion: "Versão do Agente",
    noExecutions: "Nenhuma execução encontrada",
    subtitle: "Histórico de execuções do agente",
    actions: {
      viewDetails: "Ver detalhes"
    },
    status_types: {
      pending: "Pendente",
      running: "Em execução",
      completed: "Concluído",
      error: "Erro",
      failed: "Falhou",
      canceled: "Cancelado",
      started: "Iniciado"
    }
  },
  integrations: {
    title: "Integrações",
    description: "Gerencie as integrações do agente",
    selectTitle: "Selecionar Integração",
    searchPlaceholder: "Buscar integrações...",
    selectDescription: "Escolha uma integração para adicionar ao seu agente",
    lastUpdated: "Última Atualização",
    neverUpdated: "Nunca Atualizada",
    integrationUrl: "URL da Integração",
    noIntegrationsAvailable: "Nenhuma integração disponível para adicionar",
    noSearchResults: "Nenhuma integração encontrada para sua busca",
    noDescription: "Sem descrição disponível",
    added: "✓",
    addedSuccessfully: "Integração adicionada com sucesso",
    removedSuccessfully: "Integração removida com sucesso",
    status: {
      active: "Ativo",
      inactive: "Inativo",
      pending: "Pendente",
      error: "Erro"
    }
  },
  list: {
    title: "Seus Agentes",
    description: "Gerencie seus agentes de IA",
    empty: "Você ainda não tem nenhum agente"
  },
  titleUpdated: 'Título atualizado com sucesso',
  errorUpdatingTitle: 'Erro ao atualizar o título',
} as const;

export default agents;
